import { Routes } from "@angular/router";
import { SessionGuard } from "./common/guards/session.guard";
import { AuthenticationRouteDefs } from "./features/authentication/routing/AuthenticationRouteDefs";
import { BenutzerRouteDefs } from "./features/benutzerprofil/routing/BenutzerRouteDefs";
import { BMSGPKRouteDefs } from "./features/bmsgpk/routing/BMSGPKRouteDefs";
import { FilemanagementRouteDefs } from "./features/filemanagement/routing/FilemanagementRouteDefs";
import { HelpRouteDefs } from "./features/help/routing/HelpRouteDefs";
import { HomeRouteDefs } from "./features/home/routing/HomeRouteDefs";
import { IBBetriebRouteDefs } from "./features/ib-betrieb/routing/IBBetriebRouteDefs";
import { LegalRouteDefs } from "./features/legal/routing/LegalRouteDefs";
import { NotfoundRcComponent } from "./features/notfound/routed-components/notfound-rc/notfound-rc.component";
import { RollenRouteDefs } from "./features/rollen/routing/RollenRouteDefs";
import { InfoboxRouteDefs } from "./features/infobox/routing/InfoboxRouteDefs";
import { SchnittstellendatenRouteDefs } from "./features/sms/feature/schnittstellendaten/routing/SchnittstellendatenRouteDefs";
import { SMSRouteDefs } from "./features/sms/routing/SMSRouteDefs";
import { StammdatenRouteDefs } from "./features/stammdaten/routing/StammdatenRouteDefs";
import { UsermanagementRouteDefs } from "./features/usermanagement/routing/UsermanagementRouteDefs";
import { TimemachineRouteDefs } from "./features/timemachine/routing/TimemachineRouteDefs";
export const routes: Routes = [
  //#region Redirect
  {
    path: "",
    redirectTo: HomeRouteDefs.HOME_FQ_PATH,
    pathMatch: "full",
    data: {
      hideShell: false,
    },
  },
  //#region Root Features
  //#region Auth
  {
    path: AuthenticationRouteDefs.FEATURE_PATH,
    loadChildren: () =>
      import("./features/authentication/routing/authentication.routes").then((m) => m.AUTHENTICATION_ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region Home
  {
    path: HomeRouteDefs.FEATURE_PATH,
    loadChildren: () => import("./features/home/routing/home.routes").then((m) => m.HOME_ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region User Management
  {
    path: UsermanagementRouteDefs.FEATURE_PATH,
    loadChildren: () =>
      import("./features/usermanagement/routing/usermanagement.routing").then((m) => m.USERMANAGEMENT_ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region Stammdaten
  {
    path: StammdatenRouteDefs.FEATURE_PATH,
    loadChildren: () => import("./features/stammdaten/routing/stammdaten.routes").then((m) => m.STAMMDATEN_ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region Automatic Form
  {
    path: StammdatenRouteDefs.FEATURE_PATH,
    loadChildren: () => import("./features/automatic-form/automaticForm.routes").then((m) => m.AUTOMATIC_FORM_ROUTES),
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region Help
  {
    path: HelpRouteDefs.FEATURE_PATH,
    loadChildren: () => import("./features/help/routing/help.routes").then((m) => m.HELP_ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region Rollen
  {
    path: RollenRouteDefs.FEATURE_PATH,
    loadChildren: () => import("./features/rollen/routing/rollen.routes").then((m) => m.ROLLEN_ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region Benutzerprofil
  {
    path: BenutzerRouteDefs.FEATURE_PATH,
    loadChildren: () =>
      import("./features/benutzerprofil/routing/benutzerprofil.routes").then((m) => m.BENUTZERPROFIL_ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region Filemanager
  {
    path: FilemanagementRouteDefs.FEATURE_PATH,
    loadChildren: () => import("./features/filemanagement/routing/filemanagement.routes").then((m) => m.ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region BMSGPK
  {
    path: BMSGPKRouteDefs.FEATURE_PATH,
    loadChildren: () => import("./features/bmsgpk/routing/bmsgpk.routes").then((m) => m.ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region IB-Betrieb
  {
    path: IBBetriebRouteDefs.FEATURE_PATH,
    loadChildren: () => import("./features/ib-betrieb/routing/ib-betrieb.routes").then((m) => m.ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region SMS
  {
    path: SMSRouteDefs.FEATURE_PATH,
    loadChildren: () => import("./features/sms/routing/sms.routes").then((m) => m.ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region Infobox
  {
    path: InfoboxRouteDefs.FEATURE_PATH,
    loadChildren: () => import("./features/infobox/routing/infobox.routing").then((m) => m.INFOBOX_ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region Schnittstellendaten
  {
    path: SchnittstellendatenRouteDefs.FEATURE_PATH,
    loadChildren: () =>
      import("./features/sms/feature/schnittstellendaten/routing/schnittstellendaten.routing").then((m) => m.ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region Legal
  {
    path: LegalRouteDefs.FEATURE_PATH,
    loadChildren: () => import("./features/legal/routing/legal.routes").then((m) => m.ROUTES),
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#region Zeitmaschine Timemachine
  {
    path: TimemachineRouteDefs.FEATURE_PATH,
    loadChildren: () => import("./features/timemachine/routing/timemachine.routes").then((m) => m.TIMEMACHINE_ROUTES),
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
  //#endregion

  //#endregion
  // Not Found needs to be last element!
  //#region NotFound
  {
    path: "**",
    component: NotfoundRcComponent,
    canActivate: [SessionGuard],
    data: {
      hideShell: false,
    },
  },
  //#endregion
];
